import {useState, useEffect} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import clsx from 'clsx'
import {InputTextarea} from 'primereact/inputtextarea'
import AddIcon from '@mui/icons-material/Add'
import {Button} from 'primereact/button'
import {InputText} from 'primereact/inputtext'
import {Dialog} from 'primereact/dialog'
import {Dropdown} from 'primereact/dropdown'
import {Calendar} from 'primereact/calendar'
import {Divider} from 'primereact/divider'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'

const InquirySchema = Yup.object().shape({
  studentAdmissionClass: Yup.number().required(),
  address: Yup.string().required(
    'Please enter a valid student father name with a maximum of 200 characters'
  ),
  gender: Yup.string().required(),
  firstName: Yup.string()
    .matches(/^[A-Za-z,0-9 ]*$/, 'Please enter a valid student first name')
    .max(200, 'Please enter a valid student first name with a maximum of 200 characters')
    .min(2, 'Please enter a valid student first name with a minimum of 2 characters')
    .required('Student First Name is required*'),
  fathersName: Yup.string()
    .matches(/^[A-Za-z,0-9 ]*$/, 'Please enter a valid father name')
    .max(200, 'Please enter a valid student father name with a maximum of 200 characters')
    .min(2, 'Please enter a valid father first name with a minimum of 2 characters')
    .required('Father Name is required*'),
  mothersName: Yup.string()
    .matches(/^[A-Za-z,0-9 ]*$/, 'Please enter a valid mother name')
    .max(200, 'Please enter a valid mother name with a maximum of 200 characters')
    .min(2, 'Please enter a valid mothername with a minimum of 2 characters')
    .required('Mother Name is required*'),
  lastName: Yup.string()
    .matches(/^[A-Za-z,0-9 ]*$/, 'Please enter a valid organiser name')
    .max(200, 'Please enter a valid organiser name with a maximum of 200 characters')
    .min(2, 'Please enter a valid organiser name with a minimum of 2 characters'),
  dob: Yup.date().required('Date of birth is required'),
  category: Yup.number().required(),
  city: Yup.string().required(),
  state: Yup.string().required(),
  country: Yup.string().required(),
  pincode: Yup.string()
    .matches(/^[0-9]+$/, 'Pincode must contain only digits')
    .min(5, 'Pincode number must be at least 5 characters')
    .max(7, 'Contact number must not exceed 7 characters')
    .required('Contact number is required'),
})
export default function AddEditInquiryModal({modalHeader, visible, setVisible, data}) {
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState({
    studentAdmissionClass: '',
    address: '',
    gender: '',
    firstName: '',
    fathersName: '',
    mothersName: '',
    lastName: '',
    dob: '',
    category: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
  })

  useEffect(() => {
    if (data.firstName) {
      setInitialValues({
        studentAdmissionClass: data.studentAdmissionClass,
        address: data.address,
        gender: data.gender,
        firstName: data.firstName,
        fathersName: data.fathersName,
        mothersName: data.mothersName,
        lastName: data.lastName,
        dob: data.dob,
        category: data.category,
        city: data.city,
        state: data.state,
        country: data.country,
        pincode: data.pincode,
      })
    }
  }, [data])
  var formik: any = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: InquirySchema,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
      // try {
      //   let payload = {
      //     event_id: eventId ? Number(eventId) : 0,
      //     event_type: values.type,
      //     organiser_name: values.organiser_name,
      //     organiser_image: await convertFileToBase64(values.organiserImg),
      //     title: values.title,
      //     description: values.description,
      //     start_date: formatDateToYyyyMmDd(values.start_Date),
      //     end_date: formatDateToYyyyMmDd(values.end_Date),
      //     start_time: formatTimeToHhMmSs(values.startTime),
      //     end_time: formatTimeToHhMmSs(values.endTime),
      //     paid: values.paid,
      //     amount: values.amount,
      //     max_registration: values.max_registration,
      //     max_participants: values.max_participants,
      //     cover_image: await convertFileToBase64(values.coverImg),
      //     logo: await convertFileToBase64(values.logo),
      //     available_for_classes: values.available_for_classes,
      //     details: values.details,
      //     // ...values,
      //     // eventItems: eventItems === '' ? null : eventItems,
      //   }
      //   console.log(initialValues)
      //   console.log(payload)
      //   await addEvents(payload)
      //   resetForm({values: initialValues})
      //   setformValues({...initialValues})
      //   setLogoTotalSize(0)
      //   setOrganiserTotalSize(0)
      //   setCoverTotalSize(0)
      //   logoImageUploadRef.current?.clear()
      //   organiserImageUploadRef.current?.clear()
      //   coverImageUploadRef.current?.clear()
      //   setVisible(false)
      // } catch (error) {
      //   setStatus('The login details are incorrect')
      //   setSubmitting(false)
      //   setLoading(false)
      // }
    },
  })
  console.log(formik.values)
  return (
    <Dialog
      header={modalHeader}
      visible={visible}
      position='top'
      style={{width: '55vw'}}
      onHide={() => {
        if (!visible) return
        setVisible(false)
      }}
      draggable={false}
      resizable={false}
    >
      <form onSubmit={formik.handleSubmit}>
        <div className='card'>
          <div className='card-body pb-0 pt-5'>
            <div className='row'>
              <h4 className='mb-5'>Student Personal Details</h4>
              <div className='col-6 mb-5'>
                {/* <FloatLabel> */}
                <label htmlFor='studentAdmissionClass' className='form-label'>
                  Admission for Class<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  id='studentAdmissionClass'
                  {...formik.getFieldProps('studentAdmissionClass')}
                  className='w-100'
                  placeholder='Select a class for admission'
                  value={formik.values.studentAdmissionClass || null}
                  options={[
                    {label: 'Australia', value: 1},
                    {label: 'Brazil', value: 2},
                    {label: 'China', value: 3},
                    {label: 'Egypt', value: 4},
                  ]}
                  onChange={(e) => formik.setFieldValue('studentAdmissionClass', e.value)}
                  optionLabel='label'
                />

                {formik.touched.studentAdmissionClass && formik.errors.studentAdmissionClass ? (
                  <span className='text-danger'>{formik.errors.studentAdmissionClass}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                <label htmlFor='gender' className='form-label'>
                  Gender<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  id='gender'
                  {...formik.getFieldProps('gender')}
                  placeholder='Select a gender'
                  className='w-100'
                  name='gender'
                  value={formik.values.gender || null}
                  options={[
                    {label: 'Male', value: 'Male'},
                    {label: 'Female', value: 'Female'},
                    {label: 'Other', value: 'Other'},
                  ]}
                  optionLabel='label'
                  onChange={(e) => {
                    // setformValues({...formValues, organiser_name: e.target.value})
                    formik.setFieldValue('gender', e.value)
                  }}
                  invalid={formik.touched.gender && formik.errors.gender}
                />

                {formik.touched.gender && formik.errors.gender ? (
                  <span className='text-danger'>{formik.errors.gender}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>
                  First Name<span className='text-danger'>*</span>
                </label>
                <InputText
                  type='text'
                  name='firstName'
                  placeholder='Enter Firstname'
                  {...formik.getFieldProps('firstName')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.firstName && formik.errors.firstName},
                    {
                      'is-valid': formik.touched.firstName && !formik.errors.firstName,
                    }
                  )}
                />
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>
                  Last Name<span className='text-danger'>*</span>
                </label>
                <InputText
                  type='text'
                  name='lastName'
                  placeholder='Enter Lastname'
                  {...formik.getFieldProps('lastName')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.lastName && formik.errors.lastName},
                    {
                      'is-valid': formik.touched.lastName && !formik.errors.lastName,
                    }
                  )}
                />
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>
                  Father's Name<span className='text-danger'>*</span>
                </label>
                <InputText
                  type='text'
                  name='fathersName'
                  placeholder='Enter Fathers Name'
                  {...formik.getFieldProps('fathersName')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.fathersName && formik.errors.fathersName},
                    {
                      'is-valid': formik.touched.fathersName && !formik.errors.fathersName,
                    }
                  )}
                />
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>
                  Mother's Name<span className='text-danger'>*</span>
                </label>
                <InputText
                  type='text'
                  name='mothersName'
                  placeholder='Enter Mothers name'
                  {...formik.getFieldProps('mothersName')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.mothersName && formik.errors.mothersName},
                    {
                      'is-valid': formik.touched.mothersName && !formik.errors.mothersName,
                    }
                  )}
                />
              </div>
              <div className='col-6 mb-8 position-relative'>
                <label className='form-label'>
                  Date Of Birth<span className='text-danger'>*</span>
                </label>
                <Calendar
                  name='dob'
                  id='dob'
                  {...formik.getFieldProps('dob')}
                  inputStyle={{
                    width: '88.186%',
                  }}
                  dateFormat='yy-mm-dd'
                  className={clsx(
                    'form-control bg-transparent p-0 w-100',
                    {'is-invalid': formik.touched.dob && formik.errors.dob},
                    {
                      'is-valid': formik.touched.dob && !formik.errors.dob,
                    }
                  )}
                  showIcon
                />
              </div>
              <div className='col-6 mb-8'>
                <label className='form-label'>
                  Category<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  placeholder='Select Category'
                  {...formik.getFieldProps('category')}
                  options={[
                    {value: 'General', label: 'General'},
                    {value: 'OBC', label: 'OBC'},
                    {value: 'SC/ST', label: 'SC/ST'},
                  ]}
                  value={formik.values.category || null}
                  onChange={(selectedOption: any) =>
                    formik.setFieldValue('category', selectedOption.value)
                  }
                  className='w-100'
                />
              </div>
              <Divider />
              <h4 className='mb-5'>Contact Details</h4>
              <div className='col-12 mb-5'>
                {/* <FloatLabel> */}
                <label htmlFor='address' className='form-label'>
                  Address<span className='text-danger'>*</span>
                </label>
                <InputTextarea
                  id='address'
                  {...formik.getFieldProps('address')}
                  className='w-100'
                  placeholder='Enter your Address'
                  // value={formik.values.address || null}
                  // onChange={(e) => formik.setFieldValue('address', e.value)}
                />

                {formik.touched.address && formik.errors.address ? (
                  <span className='text-danger'>{formik.errors.address}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                {/* <FloatLabel> */}
                <label htmlFor='city' className='form-label'>
                  City<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  id='city'
                  {...formik.getFieldProps('city')}
                  className='w-100'
                  placeholder='Select a city'
                  value={formik.values.city || null}
                  options={[
                    {label: 'Mumbai', value: 'Mumbai'},
                    {label: 'Delhi', value: 'Delhi'},
                    {label: 'Bangalore', value: 'Bangalore'},
                    {label: 'Egypt', value: 4},
                  ]}
                  onChange={(e) => formik.setFieldValue('city', e.value)}
                  optionLabel='label'
                />

                {formik.touched.city && formik.errors.city ? (
                  <span className='text-danger'>{formik.errors.city}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                <label htmlFor='state' className='form-label'>
                  State<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  id='state'
                  {...formik.getFieldProps('state')}
                  placeholder='Select a state'
                  className='w-100'
                  name='state'
                  value={formik.values.state || null}
                  options={[
                    {label: 'Maharashtra', value: 'Maharashtra'},
                    {label: 'Delhi', value: 'Delhi'},
                    {label: 'Rajasthan', value: 'Rajasthan'},
                  ]}
                  optionLabel='label'
                  onChange={(e) => {
                    // setformValues({...formValues, organiser_name: e.target.value})
                    formik.setFieldValue('state', e.value)
                  }}
                  invalid={formik.touched.state && formik.errors.state}
                />

                {formik.touched.state && formik.errors.state ? (
                  <span className='text-danger'>{formik.errors.state}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                <label htmlFor='country' className='form-label'>
                  Country<span className='text-danger'>*</span>
                </label>
                <Dropdown
                  id='country'
                  {...formik.getFieldProps('country')}
                  placeholder='Select a Country'
                  className='w-100'
                  name='country'
                  value={formik.values.country || null}
                  options={[
                    {label: 'India', value: 'India'},
                    {label: 'Canada', value: 'Canada'},
                    {label: 'Other', value: 'Other'},
                  ]}
                  optionLabel='label'
                  onChange={(e) => {
                    // setformValues({...formValues, organiser_name: e.target.value})
                    formik.setFieldValue('country', e.value)
                  }}
                  invalid={formik.touched.country && formik.errors.country}
                />

                {formik.touched.country && formik.errors.country ? (
                  <span className='text-danger'>{formik.errors.country}</span>
                ) : null}
              </div>
              <div className='col-6 mb-5'>
                <label className='form-label'>
                  PinCode<span className='text-danger'>*</span>
                </label>
                <InputText
                  type='text'
                  name='pincode'
                  placeholder='Enter Pincode'
                  {...formik.getFieldProps('pincode')}
                  className={clsx(
                    'form-control bg-transparent',
                    {'is-invalid': formik.touched.pincode && formik.errors.pincode},
                    {
                      'is-valid': formik.touched.pincode && !formik.errors.pincode,
                    }
                  )}
                />
              </div>
              <div className='col d-flex justify-content-end pe-1'>
                <Button
                  label='Add Inquiry'
                  type='submit'
                  severity='info'
                  rounded
                  icon={<AddIcon />}
                  style={{
                    borderRadius: '2rem',
                  }}
                  disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </Dialog>
  )
}
